var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// NOTE: structuredCloneはNode17からのサポートなのでそれまでpolyfillを使う
import structuredClone from "@ungap/structured-clone";
import { useEffect, useState } from "react";
import useSWR, { mutate, useSWRConfig } from "swr";
import { localStorage } from "./localStorage";
var genKey = function (key) { return "GLOBAL_".concat(key); };
export var mutateGlobal = function (_key, data) {
    var key = genKey(_key);
    return mutate(key, data, false);
};
export var useGlobalState = function (_key, _initialData, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var _b = options.syncLocalStorage, syncLocalStorage = _b === void 0 ? false : _b;
    var cache = useSWRConfig().cache;
    var key = genKey(_key);
    var lsData = syncLocalStorage
        ? JSON.parse((_a = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(key)) !== null && _a !== void 0 ? _a : "null")
        : null;
    var initialData = useState(lsData !== null && lsData !== void 0 ? lsData : _initialData)[0];
    if (cache.get(key) == null && initialData != null) {
        cache.set(key, __assign(__assign({}, cache.get(key)), { data: structuredClone(initialData) }));
    }
    var swrResult = useSWR(key, null, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        fallbackData: initialData,
    });
    useEffect(function () {
        if (!syncLocalStorage)
            return;
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(key, JSON.stringify(swrResult.data));
    }, [key, swrResult, syncLocalStorage]);
    return swrResult;
};
//# sourceMappingURL=useGlobalState.js.map